import { t } from '@/core/localization';
import { coreLocalStorage } from '@/core/utils/localStorage';
import { getApiUrl } from '@/shared/helpers';
import { enqueueSnackbar } from 'notistack';
import { useAuthStore } from '../auth.state';
const submitLogin = async ({ credentials, redirectTo }) => {
    const { setIsTryingToLogin, setLoginError } = useAuthStore.getState();
    setIsTryingToLogin(true);
    setLoginError(false, '');
    try {
        const { token, error } = await fetch(`${getApiUrl()}/api/Account/sign-in`, {
            method: 'POST',
            body: JSON.stringify(credentials),
            headers: {
                'Content-Type': 'application/json',
                // authorization: `Bearer ${token}`,
            },
        }).then((result) => result.json());
        setIsTryingToLogin(false);
        if (error) {
            setLoginError(true, error);
            return;
        }
        coreLocalStorage.setItem('token', token);
        window.location.replace(redirectTo);
    }
    catch (error) {
        setIsTryingToLogin(false);
        // setLoginError(true, getQueryErrorMessage(error as SerializedError) );
        setLoginError(true, error);
        enqueueSnackbar({ variant: 'error', header: t('authorization.error'), body: t('see.console.for.more.info'), persist: true });
        console.error(`Login failed.`, error);
    }
};
// TODO: to delete later
// export const getCurrentUser = async (credentials: string): Promise<CurrentUser> => {
// 	const { expiration, userId } = decodeToken(token);
// 	const response: LoginResponse = await fetch(`${getApiUrl()}/api/userinfo`, {
// 		method: 'GET',
// 		cache: 'no-cache',
// 		body: credentials,
// 		// headers: {
// 		// 	// 'Content-Type': 'application/json',
// 		// 	authorization: `Bearer ${token}`,
// 		// },
// 	}).then((result) => result.json());
// 	return {
// 		expiration,
// 		userId: userInfo.userId,
// 		userFullName: userInfo.userFullName,
// 		userEmail: userInfo.userEmail,
// 		avatar: userInfo.thumbnail,
// 		roles: userInfo.roles,
// 		claims: userInfo.claims,
// 		crossDockIds: userInfo.crossDockIds,
// 		locationIds: userInfo.locationIds,
// 	};
// };
export { submitLogin };
